// @flow

import { FORM_VALIDATIONS } from '@riseart/form';
import { dialingCodes as DIALING_CODES } from 'Countries';

export const EnquireBaseFormModel = {
  settings: {
    hideRequiredMark: true,
    layout: 'horizontal',
  },
  fields: [
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      validateTrigger: 'onBlur',
      rules: [
        {
          type: 'email',
          message: 'forms.common.validation_messages.not_valid_email',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_email',
        },
      ],
      label: 'forms.emailEnquire.placeholder.email',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'fullName',
      validateTrigger: 'onBlur',
      rules: [
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.notValidName',
        },
      ],
      label: 'forms.emailEnquire.placeholder.name',
    },
    {
      tag: 'phone',
      type: 'phone',
      name: 'phone',
      validateTrigger: 'onBlur',
      rules: FORM_VALIDATIONS.PHONE,
      label: 'forms.emailEnquire.placeholder.phone',
      dialingCodes: DIALING_CODES,
      initialCountryCode: 'gb',
    },
  ],
};
